<div class="model-viewer-wrapper" [class.cursor-crosshair]="isAddMarkerMode" [class.cursor-measure]="isMeasureDistanceMode || isMeasureAngleMode || isMeasureAreaMode">
  <app-model-viewer-3d
    *ngIf="viewerMode === '3D'"
    [modelUrl]="modelUrl"
    [markers]="markers3D"
    [isAddMarkerMode]="isAddMarkerMode"
    [isGizmoMode]="isGizmoMode"
    [markersVisible]="markersVisible"
    [isMeasureDistanceMode]="isMeasureDistanceMode"
    [isMeasureAngleMode]="isMeasureAngleMode"
    [isMeasureAreaMode]="isMeasureAreaMode"
    [woundMetrics]="woundMetrics"
    (markerClick)="on3DMarkerClick($event)"
    (markerAdd)="on3DMarkerAdd($event)"
    (modelLoaded)="onModelLoaded()"
    (modelLoadError)="onModelLoadError($event)"
    (measurementResult)="onMeasurementResult($event)"
  ></app-model-viewer-3d>

  <!-- Measurement Sidebar — sadece analiz viewer'da göster -->
  <app-measurement-sidebar
    *ngIf="viewerMode === '3D' && showMeasurementSidebar"
    [activeTool]="activeMeasurementTool"
    [isContrastMode]="isTextureMode"
    [isTextureMode]="showTexture"
    [areaPointCount]="viewer3D?.areaPointCount ?? 0"
    (toolAction)="onMeasurementAction($event)"
  ></app-measurement-sidebar>

  <!-- Measurement Result Display -->
  <div class="measurement-result" *ngIf="lastMeasurementResult">
    <ng-container *ngIf="lastMeasurementResult.type === 'area'">
      <i class="fas fa-draw-polygon"></i>
      <span class="result-row">
        <span class="result-item">
          <span class="result-lbl">{{ 'modelViewer.perimeterUnit' | translate }}</span>
          <span class="result-val">{{ lastMeasurementResult.extra?.perimeterLabel }}</span>
        </span>
        <span class="result-sep">·</span>
        <span class="result-item">
          <span class="result-lbl">{{ 'modelViewer.areaUnit' | translate }}</span>
          <span class="result-val">{{ lastMeasurementResult.extra?.areaLabel ?? (lastMeasurementResult.value.toFixed(2) + ' cm²') }}</span>
        </span>
      </span>
    </ng-container>
    <ng-container *ngIf="lastMeasurementResult.type !== 'area'">
      <i class="fas fa-ruler"></i>
      <span>{{ lastMeasurementResult.label }}</span>
    </ng-container>
    <button class="close-result-btn" (click)="lastMeasurementResult = null; clearMeasurementModes()">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <app-model-viewer-2d
    *ngIf="viewerMode === '2D'"
    [modelUrl]="modelUrl"
    [rectangles]="rectangles2D"
    [isDrawingMode]="isDrawing2DMode"
    [isSelectMode]="isSelect2DMode"
    [pendingRect]="pendingRectangle"
    (rectangleAdd)="on2DRectangleAdd($event)"
    (rectangleClick)="on2DRectangleClick($event)"
    (modelLoaded)="onModelLoaded()"
  ></app-model-viewer-2d>

  <app-marker-controls
    *ngIf="viewerMode !== 'NONE'"
    [viewerMode]="viewerMode"
    [count]="markerCount"
    [markersVisible]="markersVisible"
    [isGizmoMode]="isGizmoMode"
    [isAddMarkerMode]="isAddMarkerMode"
    [isDrawing2DMode]="isDrawing2DMode"
    [isSelect2DMode]="isSelect2DMode"
    [selectedMarkerId]="selectedMarkerId"
    [isMetricsActive]="showMetricsPanel"
    [allowAnnotation]="allowAnnotation"
    [hide2DToolbar]="hide2DToolbar"
    [hide3DDeleteButton]="hide3DDeleteButton"
    (action)="onControlAction($event)"
  ></app-marker-controls>

  <div class="metrics-panel" *ngIf="showMetricsPanel">
    <div class="panel-header">
      <i class="fas fa-chart-pie"></i>
      <span>{{ "modelViewer.metrics" | translate }}</span>
    </div>
    <div class="cards-container" *ngIf="metrics.length > 0; else noMetrics">
      <div class="metric-card" *ngFor="let metric of metrics">
        <div class="card-icon">
          <i [class]="metric.icon"></i>
        </div>
        <div class="card-content">
          <span class="metric-label">{{ metric.label }}</span>
          <div class="metric-value-group">
            <span class="metric-value">{{ metric.value }}</span>
            <span class="metric-unit">{{ metric.unit }}</span>
          </div>
        </div>
      </div>
    </div>
    <ng-template #noMetrics>
      <div class="metrics-empty">
        <i class="fas fa-microscope"></i>
        <span>{{ "modelViewer.metricsNotFound" | translate }}</span>
      </div>
    </ng-template>
  </div>

  <!-- Loading State -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner"></div>
    <span>{{ "modelViewer.loading" | translate }}</span>
  </div>

  <!-- Error State -->
  <div class="error-overlay" *ngIf="hasError">
    <i class="fas fa-exclamation-triangle"></i>
    <span>{{ "modelViewer.loadError" | translate }}</span>
  </div>

  <!-- Settings Button -->
  <button
    class="settings-btn"
    *ngIf="viewerMode === '3D'"
    (click)="toggleControls()"
    [title]="'modelViewer.settings' | translate"
    [class.active]="showControls"
  >
    <i class="fas fa-sliders-h"></i>
  </button>

  <!-- Help Button -->
  <button
    class="help-btn"
    *ngIf="viewerMode === '3D'"
    (click)="toggleHelp()"
    [title]="'modelViewer.help' | translate"
    [class.active]="showHelp"
  >
    <i class="fas fa-question"></i>
  </button>

  <!-- Color Controls Panel -->
  <div class="color-controls-panel" *ngIf="showControls && viewerMode === '3D'">
    <div class="control-group">
      <label>
        <i class="fas fa-sun"></i>
        {{ "modelViewer.brightness" | translate }}
      </label>
      <input
        type="range"
        [min]="0.5"
        [max]="2.0"
        [step]="0.1"
        [value]="brightness"
        (input)="updateBrightness($event)"
      />
    </div>

    <div class="control-group horizontal-layout">
      <label>
        <i class="fas fa-adjust"></i>
        {{ "modelViewer.contrastMode" | translate }}
      </label>
      <div
        class="toggle-switch"
        (click)="toggleTextureMode()"
        [class.active]="isTextureMode"
      >
        <div class="toggle-knob"></div>
      </div>
    </div>

    <div class="control-group horizontal-layout">
      <label>
        <i class="fas fa-layer-group"></i>
        {{ "modelViewer.texture" | translate }}
      </label>
      <div
        class="toggle-switch"
        (click)="toggleTexture()"
        [class.active]="showTexture"
      >
        <div class="toggle-knob"></div>
      </div>
    </div>
  </div>

  <!-- Reset View Button -->
  <button
    class="reset-view-btn"
    *ngIf="viewerMode === '3D'"
    (click)="resetView()"
    [title]="'modelViewer.resetView' | translate"
  >
    <i class="fas fa-sync-alt"></i>
  </button>

  <div
    class="tooltip"
    *ngIf="viewerMode === '3D' && hoverText"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY"
  >
    {{ hoverText }}
  </div>

  <div
    class="marker-note-display"
    *ngIf="viewerMode === '3D' && hoveredMarkerNote"
    [style.left.px]="tooltipX"
    [style.top.px]="tooltipY"
  >
    <div class="note-header">{{ "modelViewer.markerNote" | translate }}</div>
    <div class="note-content">{{ hoveredMarkerNote }}</div>
  </div>

  <!-- Help Modal Overlay -->
  <div class="help-overlay-backdrop" *ngIf="showHelp" (click)="toggleHelp()">
    <div class="help-modal" (click)="$event.stopPropagation()">
      <div class="help-header">
        <h3>
          <i class="fas fa-info-circle"></i>
          {{ "modelViewer.helpTitle" | translate }}
        </h3>
        <button class="close-btn" (click)="toggleHelp()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="help-content">
        <div class="help-section">
          <h4>{{ "modelViewer.mouseControls" | translate }}</h4>
          <ul>
            <li>
              <i class="fas fa-mouse-pointer"></i>
              <span>{{ "modelViewer.rotateHelp" | translate }}</span>
            </li>
            <li>
              <i class="fas fa-hand-paper"></i>
              <span>{{ "modelViewer.panHelp" | translate }}</span>
            </li>
            <li>
              <i class="fas fa-search-plus"></i>
              <span>{{ "modelViewer.zoomHelp" | translate }}</span>
            </li>
          </ul>
        </div>

        <div class="help-section">
          <h4>{{ "modelViewer.generalControls" | translate }}</h4>
          <ul>
            <li>
              <i class="fas fa-sync-alt"></i>
              <span>{{ "modelViewer.resetViewHelp" | translate }}</span>
            </li>
            <li>
              <i class="fas fa-sun"></i>
              <span>{{ "modelViewer.brightnessHelp" | translate }}</span>
            </li>
            <li>
              <i class="fas fa-adjust"></i>
              <span>{{ "modelViewer.contrastModeHelp" | translate }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <app-marker-note-modal
    [visible]="showNoteModal"
    [note]="currentNote"
    [isEditing]="isEditingMode"
    (save)="onNoteSave($event)"
    (cancel)="closeNoteModal()"
    (delete)="onNoteDeleteFromModal()"
  ></app-marker-note-modal>
</div>
